import React from 'react';
import { useTranslation } from 'react-i18next';

import { SHAPE_GROUPS } from '../../config';
import { useMediaStudio } from '../../context/MediaStudioContext';
import PanelBody from '../../components/panel-body/PanelBody';
import PanelSection from '../../components/panel-section/PanelSection';
import PreviewCard, { PREVIEW_CARD_BACKDROPS } from '../../components/preview-card/PreviewCard';
import ShapePreview from './components/shape-preview/ShapePreview';

import scss from './ElementsPanel.module.scss';

function ElementsPanel() {
  const { t } = useTranslation('mediaStudio');
  const { editor } = useMediaStudio();

  return (
    <PanelBody>
      {SHAPE_GROUPS.map((group) => {
        const isLayout = group.id === 'layout';
        return (
          <PanelSection key={group.id} title={t(group.labelKey)}>
            <div className={isLayout ? scss.gridWide : scss.grid}>
              {group.presets.map((preset) => (
                <PreviewCard
                  key={preset.id}
                  name={t(preset.nameKey)}
                  backdrop={isLayout ? PREVIEW_CARD_BACKDROPS.PHOTO : PREVIEW_CARD_BACKDROPS.SURFACE}
                  frameClassName={scss.shapeFrame}
                  onClick={() => editor.addShape(preset, t(preset.nameKey))}>
                  <ShapePreview id={preset.id} />
                </PreviewCard>
              ))}
            </div>
          </PanelSection>
        );
      })}
    </PanelBody>
  );
}

export default ElementsPanel;
